var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-10',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-header"},[_c('h3',{staticStyle:{"font-size":"40px"}},[_vm._v("人员在场曲线图")])]),_c('div',{ref:"bepresent",staticStyle:{"width":"95%","height":"80%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }